import styled from 'styled-components';
import Loader from '@ts/ui/Loader';

export const ControlledDayPicker = styled.div`
    position: relative;

    .DayPicker {
        box-shadow: none;
        background: transparent;
        font-family: Montserrat, Helvetica, Verdana, Arial, sans-serif;
        font-display: optional;
    }

    .DayPicker-wrapper {
        outline: none;
    }

    .DayPicker-Caption {
        text-align: center;
        color: rgb(72, 72, 72);
        font-weight: bolder;
        padding-top: 10px;
        > div {
            font-weight: 700;
        }
    }

    .DayPicker-Weekday {
        font-size: 80%;
        color: #6f6f6f;
    }

    .DayPicker-Month {
        margin: 1em 0.85em 0;
    }

    .DayPicker-NavBar {
        position: relative;
    }

    .DayPicker-Day {
        position: relative;
        border-radius: 0;
        color: rgb(72, 72, 72);
        outline: none;
        border: 1px solid rgb(228, 231, 231);
        transition: background-color 0.1s linear;

        &:hover {
            background-color: rgb(228, 231, 231);
        }

        &.DayPicker-Day--disabled {
            color: rgb(202, 204, 205);
            &,
            &:hover {
                background-color: transparent;
            }
        }

        &.DayPicker-Day--outside {
            &,
            &:hover {
                border: 0;
                background-color: transparent;
            }
        }

        &:not(.DayPicker-Day--outside) {
            &.DayPicker-Day--endOffset {
                background-color: rgb(228, 231, 231);
            }

            &.DayPicker-Day--selected {
                background-color: rgb(0, 187, 101);
                border-color: rgb(0, 187, 101);
                &:hover {
                    background-color: rgb(7, 183, 102);
                }
            }

            &.DayPicker-Day--lastInRange,
            &.DayPicker-Day--firstInRange {
                background-color: rgb(0, 154, 83);
                border-color: rgb(0, 154, 83);
                &:hover {
                    background-color: rgb(7, 183, 102);
                }
            }

            &.DayPicker-Day--blocked {
                &:not(.DayPicker-Day--selected),
                &:not(.DayPicker-Day--selected):hover {
                    border-color: #ddd;
                }

                &,
                &:hover {
                    color: #777;
                    background: #ddd !important;
                    border-bottom-color: #ddd;
                    border-right-color: #ddd;
                    cursor: initial;

                    &.DayPicker-Day--firstInRange {
                        background: #cecece !important;
                        border-bottom-color: #cecece;
                        border-right-color: #cecece;
                    }
                }
            }
        }
    }
`;

export const Dimmer = styled.div`
    position: absolute;
    top: 55px;
    width: 100%;
    height: calc(100% - 55px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 15;
    background: rgba(255, 255, 255, 0.62);

    ${Loader} {
        margin-top: -55px;
    }
`;
